import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  cta,
}: {
  title: string;
  description?: string;
  cta?: ReactNode;
}) {
  return (
    <div className="fk-empty-state">
      <div className="fk-empty-state__message">
        <div className="fk-empty-state__message-title">{title}</div>
        {description ? <div className="fk-empty-state__message-desc">{description}</div> : null}
      </div>
      {cta ? <div className="fk-empty-state__cta">{cta}</div> : null}
    </div>
  );
}
